import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppComponent } from './app.component';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { LoaderModule } from './loader/loader.module';
import { ToastModule} from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FooterModule } from './shared/footer/footer.module';
import { DialogModule } from 'primeng/dialog';


@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FontAwesomeModule,
    LoaderModule,
    ToastModule,
    ConfirmDialogModule,
    TranslateModule,
    FooterModule,
    DialogModule,
  ],
  providers: [
    ConfirmationService,
    MessageService,
  ],
  exports: [
    AppComponent,
  ]
})
export class AppComponentModule { }
